export default __webpack_public_path__ + "static/media/firstImg.e656db37.jpg";